import { render, staticRenderFns } from "./VxCollapseItem.vue?vue&type=template&id=3c25d65f&"
import script from "./VxCollapseItem.vue?vue&type=script&lang=js&"
export * from "./VxCollapseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports